/* Confortex — custom shop features (Axynoxia)
   Vanilla JS, no dependencies. Loaded deferred from theme.liquid. */
(function () {
  'use strict';

  /* ---------------------------------------------------------------------
     Money formatting — reuses the shop's own money format string exposed
     by the theme (window.T4Sconfigs.money_format) so currency, decimals
     and separators always match the storefront.
     --------------------------------------------------------------------- */
  function formatMoney(cents) {
    var format =
      (window.T4Sconfigs && (window.T4Sconfigs.moneyFormat || window.T4Sconfigs.money_format)) ||
      (window.Shopify && window.Shopify.money_format) ||
      '{{amount}}';

    function fmt(number, precision, thousands, decimal) {
      if (isNaN(number) || number === null) return '0';
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var head = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return parts[1] ? head + decimal + parts[1] : head;
    }

    var value = '';
    var match = /\{\{\s*(\w+)\s*\}\}/.exec(format);
    var placeholder = match ? match[1] : 'amount';

    switch (placeholder) {
      case 'amount': value = fmt(cents, 2, ',', '.'); break;
      case 'amount_no_decimals': value = fmt(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = fmt(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = fmt(cents, 0, ' ', ','); break;
      case 'amount_with_period_and_space_separator': value = fmt(cents, 2, ' ', '.'); break;
      default: value = fmt(cents, 2, ',', '.');
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  /* =====================================================================
     1. Dimension selector
     ===================================================================== */
  function initSizeSelector(root) {
    if (root.dataset.cfxReady === '1') return;
    root.dataset.cfxReady = '1';

    var toggle = root.querySelector('.cfx-size__toggle');
    var panel = root.querySelector('.cfx-size__panel');
    if (!panel) return;

    var valueEl = root.querySelector('.cfx-size__toggle-value');
    var priceEl = root.querySelector('.cfx-size__toggle-price');

    var currentEl = root.querySelector('[data-current-value]');

    // This function must stay read-only. It runs from a MutationObserver that
    // watches the very nodes it looks at, and observer callbacks are async, so
    // a re-entrancy flag cannot protect it — any class it wrote here would be
    // re-applied by the theme and loop forever.
    function syncToggle() {
      // The theme keeps [data-current-value] authoritative for the selected
      // option, so match on that first. Relying on .is--selected alone is not
      // safe: the theme applies that class during its own variant/colour
      // logic, so several rows can carry it at once and querySelector would
      // return whichever comes first in the DOM — not necessarily the one the
      // customer picked.
      var selected = null;
      var current = currentEl ? (currentEl.textContent || '').trim() : '';

      if (current) {
        var items = panel.querySelectorAll('.t4s-swatch__item');
        for (var i = 0; i < items.length; i++) {
          if ((items[i].getAttribute('data-value') || '').trim() === current) {
            selected = items[i];
            break;
          }
        }
      }
      if (!selected) selected = panel.querySelector('.t4s-swatch__item.is--selected');
      if (!selected) return;

      var v = selected.getAttribute('data-value') || '';
      var p = selected.getAttribute('data-cfx-price') || '';
      // Write only on an actual change, so the toggle never churns.
      if (valueEl && valueEl.textContent !== v) valueEl.textContent = v;
      if (priceEl && priceEl.textContent !== p) priceEl.textContent = p;
    }

    function close() { root.classList.remove('is--open'); }

    if (toggle) {
      toggle.addEventListener('click', function (e) {
        e.preventDefault();
        root.classList.toggle('is--open');
      });
    }

    // Let the theme handle the actual variant change (it listens on
    // [data-swatch-item]); we only close the panel afterwards.
    panel.addEventListener('click', function (e) {
      if (e.target.closest('.t4s-swatch__item')) {
        setTimeout(function () { syncToggle(); close(); }, 0);
      }
    });

    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) close();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });

    // The theme flips is--selected itself on variant change (including from
    // the URL or a linked colour swatch), so mirror it back into the toggle.
    new MutationObserver(syncToggle).observe(panel, {
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });

    // [data-current-value] sits outside the panel and is now the source of
    // truth, so watch its text as well — otherwise a variant change that only
    // rewrites the label would leave the toggle stale.
    if (currentEl) {
      new MutationObserver(syncToggle).observe(currentEl, {
        subtree: true,
        characterData: true,
        childList: true
      });
    }

    syncToggle();
  }

  /* =====================================================================
     2. Sur-mesure calculator popup
     ===================================================================== */
  function initSurMesure(modal) {
    if (modal.dataset.cfxReady === '1') return;
    modal.dataset.cfxReady = '1';

    var cfg = {};
    try { cfg = JSON.parse(modal.getAttribute('data-cfx-config') || '{}'); } catch (e) { cfg = {}; }

    var widthEl = modal.querySelector('[data-cfx-sm-width]');
    var lengthEl = modal.querySelector('[data-cfx-sm-length]');
    var thickEl = modal.querySelector('[data-cfx-sm-thickness]');
    var priceEl = modal.querySelector('[data-cfx-sm-price]');
    var errorEl = modal.querySelector('[data-cfx-sm-error]');
    var calcEl = modal.querySelector('[data-cfx-sm-calc]');
    var atcEl = modal.querySelector('[data-cfx-sm-atc]');
    var atcMsgEl = modal.querySelector('[data-cfx-sm-atc-msg]');
    var lastCalc = null;

    function num(el) { return el ? parseFloat(el.value) : NaN; }

    function compute() {
      var w = num(widthEl);
      var l = num(lengthEl);
      var factor = thickEl ? parseFloat(thickEl.value) || 1 : 1;
      var errors = [];

      if (!w || !l) errors.push(cfg.msg_required || 'Renseignez la longueur et la largeur.');
      if (w && (w < cfg.min_width || w > cfg.max_width)) {
        errors.push((cfg.msg_width || 'Largeur autorisée : {min} à {max} cm.')
          .replace('{min}', cfg.min_width).replace('{max}', cfg.max_width));
      }
      if (l && (l < cfg.min_length || l > cfg.max_length)) {
        errors.push((cfg.msg_length || 'Longueur autorisée : {min} à {max} cm.')
          .replace('{min}', cfg.min_length).replace('{max}', cfg.max_length));
      }

      if (errorEl) errorEl.textContent = errors[0] || '';

      if (errors.length) {
        if (priceEl) priceEl.textContent = '—';
        if (calcEl) calcEl.textContent = '';
        lastCalc = null;
        if (atcEl) atcEl.disabled = true;
        return null;
      }

      // Confortex tariff (« Prix sur mesures ») — the price per m² is not a
      // single number: it depends on the gamme AND on the length of the
      // mattress, in three bands. The gamme is already resolved server-side
      // (the rates come from the product/collection), the band is resolved
      // here from the length the customer typed.
      //     length <  180 cm          → rate_under_180
      //     180 <= length <= 200 cm    → rate_180_200
      //     length >  200 cm          → rate_over_200
      // price = surface(m²) × rate × thickness factor  (+ optional base),
      // rounded up to the nearest `round_to` (values in cents/millimes).
      var rate;
      if (l < 180) rate = cfg.rate_under_180;
      else if (l <= 200) rate = cfg.rate_180_200;
      else rate = cfg.rate_over_200;

      // A band with no published tariff (« *** » in the price sheet) means
      // this size is quote-only: show no price, and send the shopper to
      // WhatsApp (see the popup markup) since there is no cart price to add.
      if (!rate) {
        if (priceEl) priceEl.textContent = cfg.msg_on_quote || '—';
        if (calcEl) calcEl.textContent = '';
        lastCalc = null;
        if (atcEl) atcEl.disabled = true;
        return null;
      }

      var surface = (w * l) / 10000;
      var raw = (cfg.base_price || 0) + surface * rate * factor;
      var step = cfg.round_to || 1;
      var total = Math.ceil(raw / step) * step;

      // The cart charges whole units of the unit product, so the quoted price
      // must be the rounded one — otherwise the popup quotes 821.66 and the
      // cart takes 822.000. Falls back to the raw total when no unit product
      // is configured (request-form-only mode).
      var charged = total;
      if (cfg.unit_variant_id && cfg.unit_price) {
        var units = Math.round(total / cfg.unit_price);
        if (units < 1) units = 1;
        charged = units * cfg.unit_price;
      }

      if (priceEl) priceEl.textContent = formatMoney(charged);

      // Spell out the cm -> m² conversion and the rate applied, so the price
      // is auditable rather than a bare number.
      if (calcEl) {
        var m2 = surface.toFixed(2).replace('.', ',');
        calcEl.textContent = (cfg.msg_calc || '{l} × {w} cm = {m2} m² × {rate}/m²')
          .replace('{w}', w)
          .replace('{l}', l)
          .replace('{m2}', m2)
          .replace('{rate}', formatMoney(rate));
      }

      lastCalc = { w: w, l: l, total: total, charged: charged, rate: rate, calc: calcEl ? calcEl.textContent : '' };
      if (atcEl) atcEl.disabled = false;

      return total;
    }


    /* ---------------------------------------------------------------
       Add to cart.

       Shopify's /cart/add.js cannot be given a free-form price, so the
       custom size is added as N units of a hidden "unit" product whose
       price is known (1 DT by default): quantity = total / unit price.
       The real dimensions and the calculation travel as line-item
       properties, which is what the shop and the customer actually read.
       --------------------------------------------------------------- */
    function addToCart() {
      if (!lastCalc || !cfg.unit_variant_id || !cfg.unit_price) return;

      var qty = Math.round(lastCalc.total / cfg.unit_price);
      if (qty < 1) qty = 1;

      var props = {};
      props[cfg.prop_product || 'Gamme'] = cfg.product_title || '';
      props[cfg.prop_dims || 'Dimensions'] = lastCalc.l + ' × ' + lastCalc.w + ' cm';
      if (lastCalc.calc) props[cfg.prop_calc || 'Calcul'] = lastCalc.calc;
      // Marker used to spot these lines in the cart and hide the quantity.
      props._cfx_surmesure = '1';

      atcEl.disabled = true;
      if (atcMsgEl) { atcMsgEl.textContent = ''; atcMsgEl.className = 'cfx-sm__atc-msg'; }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: cfg.unit_variant_id, quantity: qty, properties: props }] })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        })
        .then(function () {
          if (atcMsgEl) {
            atcMsgEl.textContent = cfg.msg_atc_done || 'Ajouté au panier';
            atcMsgEl.className = 'cfx-sm__atc-msg is--ok';
          }
          // Let the theme refresh its own cart drawer/count.
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          setTimeout(function () { close(); }, 700);
        })
        .catch(function () {
          if (atcMsgEl) {
            atcMsgEl.textContent = cfg.msg_atc_error || 'Ajout impossible.';
            atcMsgEl.className = 'cfx-sm__atc-msg is--err';
          }
          atcEl.disabled = false;
        });
    }

    if (atcEl) atcEl.addEventListener('click', addToCart);

    [widthEl, lengthEl, thickEl].forEach(function (el) {
      if (el) { el.addEventListener('input', compute); el.addEventListener('change', compute); }
    });

    function open() {
      // Re-parent to <body> so no transformed/positioned ancestor (the product
      // form, the sticky bar) can trap the popup in its stacking context and
      // let the header paint over it.
      if (modal.parentNode !== document.body) document.body.appendChild(modal);
      if (atcMsgEl) { atcMsgEl.textContent = ''; atcMsgEl.className = 'cfx-sm__atc-msg'; }
      modal.classList.add('is--open');
      document.body.classList.add('cfx-sm-open');
      document.body.style.overflow = 'hidden';
      compute();
    }
    function close() {
      modal.classList.remove('is--open');
      document.body.classList.remove('cfx-sm-open');
      document.body.style.overflow = '';
    }

    modal.querySelectorAll('[data-cfx-sm-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-cfx-sm-open]');
      if (!trigger) return;
      if (trigger.getAttribute('data-cfx-sm-open') !== modal.id) return;
      e.preventDefault();
      open();
    });

    compute();
  }

  /* =====================================================================
     2b. Cart lines for custom sizes

     The custom size is added as N units of a unit product, so the raw
     quantity equals the price and must not be shown. These lines are found
     by the unit product's handle (exposed in theme.liquid) and their
     quantity widget is hidden; the dimensions still show as line-item
     properties, which is what the customer needs to see.
     ===================================================================== */
  var cfxCartFetching = false;

  function tidySurMesureCartLines(scope) {
    var handle = window.CFX_SM_UNIT_HANDLE;
    if (!handle) return;

    var links = (scope || document).querySelectorAll('a[href*="/products/' + handle + '"]');
    if (!links.length) return;

    var fresh = false;
    for (var i = 0; i < links.length; i++) {
      var row = links[i].closest('[data-cart-item], .t4s-mini_cart__item, .t4s-page_cart__item, tr, li');
      if (!row || row.dataset.cfxSmTidied === '1') continue;
      row.dataset.cfxSmTidied = '1';
      row.classList.add('cfx-sm-line');
      fresh = true;
    }
    if (fresh) fixSurMesureLinePrices();
  }

  /* The quantity is hidden on these lines because it carries the price, but
     the theme prints the UNIT price next to it — which would read as 1 DT for
     a whole mattress. The real line total is taken from /cart.js and written
     in its place, matched on the Dimensions property so multiple custom sizes
     stay distinct. */
  function fixSurMesureLinePrices() {
    var handle = window.CFX_SM_UNIT_HANDLE;
    if (!handle || cfxCartFetching) return;
    cfxCartFetching = true;

    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        (cart.items || []).forEach(function (item) {
          if (item.handle !== handle) return;
          var dims = item.properties && (item.properties.Dimensions || item.properties.dimensions);
          if (!dims) return;

          document.querySelectorAll('.cfx-sm-line').forEach(function (row) {
            if (row.textContent.indexOf(dims) === -1) return;
            var priceEl = row.querySelector(
              '.t4s-cart_price, [data-cart-item-price], .t4s-mini_cart__price, .t4s-cart__price, .t4s-price'
            );
            if (priceEl) priceEl.textContent = formatMoney(item.final_line_price);
          });
        });
      })
      .catch(function () { /* leave the theme's own price in place */ })
      .then(function () { cfxCartFetching = false; });
  }

  /* =====================================================================
     3. Complementary accessories — keep the chosen variant id in sync with
        the size dropdown, pre-select the accessory variant matching the
        host product's own dimension (a 190x90 mattress defaults to the
        190x90 protector, not just "first available"), and add to cart
        ourselves so the theme's global handler never opens the cart drawer.
     ===================================================================== */

  // "190×90", "90 x 190", "190*90" (the protector's own naming) all normalise
  // to "90x190", smallest side first, so the mattress and its accessory match
  // whichever way either product was named. Anything around the size (colour,
  // price) is ignored.
  function normalizeDims(str) {
    var m = /(\d+(?:[.,]\d+)?)\s*[x×*]\s*(\d+(?:[.,]\d+)?)/i.exec(String(str || ''));
    if (!m) return '';
    var a = parseFloat(m[1].replace(',', '.')), b = parseFloat(m[2].replace(',', '.'));
    return a <= b ? a + 'x' + b : b + 'x' + a;
  }

  // The main product's own dimension selector: the full product page is the
  // only place that renders the sur-mesure variant (dropdown3), which keeps
  // the sticky bar and quick view out of it.
  function hostSizeSelector() {
    return document.querySelector('.cfx-size--dropdown3') || document.querySelector('.cfx-size');
  }

  function currentHostDims() {
    var host = hostSizeSelector();
    var current = host && host.querySelector('[data-current-value]');
    return current ? normalizeDims(current.textContent) : '';
  }

  function initAccessories(root) {
    if (root.dataset.cfxReady === '1') return;
    root.dataset.cfxReady = '1';

    // Client order: colour, dimension, then this block, i.e. before the
    // quantity and add to cart. Rendered as its own block, it is moved here.
    var host = hostSizeSelector();
    var swatch = host && host.closest('.t4s-swatch');
    if (swatch && swatch.parentNode) swatch.parentNode.insertBefore(root, swatch.nextSibling);

    root.querySelectorAll('[data-cfx-acc-row]').forEach(function (row) {
      var select = row.querySelector('[data-cfx-acc-select]');
      var button = row.querySelector('[data-cfx-acc-add]');
      var msg = row.querySelector('[data-cfx-acc-msg]');
      var priceEl = row.querySelector('[data-cfx-acc-price]');
      var variantId = row.dataset.variantId;

      function sync() {
        if (!select) return;
        var opt = select.options[select.selectedIndex];
        variantId = select.value;
        if (button) button.disabled = opt ? opt.disabled : false;
        if (priceEl && opt && opt.dataset.price) priceEl.textContent = opt.dataset.price;
      }

      // Pick the option whose own title matches the host product's current
      // dimension, when one is available; otherwise keep the default (first
      // available) selection.
      function matchHostDims() {
        if (!select) return;
        var hostDims = currentHostDims();
        if (!hostDims) return;
        for (var i = 0; i < select.options.length; i++) {
          var opt = select.options[i];
          if (opt.disabled) continue;
          if (normalizeDims(opt.textContent) === hostDims) {
            select.selectedIndex = i;
            break;
          }
        }
      }

      if (select) {
        // Kept away from the product form's own change handlers now that the
        // block sits inside that form.
        select.addEventListener('change', function (e) { e.stopPropagation(); sync(); });
        matchHostDims();
        sync();

        // Re-match when the shopper changes the main product's dimension. The
        // theme fires variant:changed through jQuery; the size label is also
        // watched in case a change arrives without that event.
        if (window.jQuery) {
          window.jQuery(document).on('variant:changed', function () { matchHostDims(); sync(); });
        }
        var hostLabel = host && host.querySelector('[data-current-value]');
        if (hostLabel && window.MutationObserver) {
          new MutationObserver(function () { matchHostDims(); sync(); })
            .observe(hostLabel, { subtree: true, characterData: true, childList: true });
        }
      }

      if (!button) return;
      button.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (button.disabled || !variantId) return;

        button.disabled = true;
        if (msg) { msg.textContent = ''; msg.className = 'cfx-acc__msg'; }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
        })
          .then(function (r) {
            if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || 'add failed'); });
            return r.json();
          })
          .then(function () {
            button.classList.add('is--added');
            if (msg) { msg.textContent = button.dataset.doneLabel || ''; msg.className = 'cfx-acc__msg is--ok'; }
            // cart:refresh updates the theme's cart without opening the drawer
            // (cart:refresh:opend is the event that opens it).
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            setTimeout(function () { button.classList.remove('is--added'); button.disabled = false; sync(); }, 1500);
          })
          .catch(function (err) {
            if (msg) { msg.textContent = err.message || ''; msg.className = 'cfx-acc__msg is--err'; }
            button.disabled = false;
          });
      });
    });
  }

  /* ===================================================================== */
  function init() {
    document.querySelectorAll('.cfx-size').forEach(initSizeSelector);
    document.querySelectorAll('.cfx-sm').forEach(initSurMesure);
    document.querySelectorAll('.cfx-acc').forEach(initAccessories);
    tidySurMesureCartLines();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-run after the theme swaps product markup (quick view, section reload).
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('load', init);

  // The cart drawer is re-rendered by the theme over AJAX, so custom-size
  // lines have to be re-tagged each time its contents change.
  if (window.MutationObserver) {
    new MutationObserver(function () { tidySurMesureCartLines(); }).observe(
      document.documentElement, { subtree: true, childList: true }
    );
  }
  document.addEventListener('cart:refresh', function () {
    setTimeout(function () { tidySurMesureCartLines(); }, 300);
  });
})();
